/* Publish by EComposer at 2026-10-27 06:10:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ni5z8d5s9cg"]=  window.__ectimmers["ecom-ni5z8d5s9cg"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ni5z8d5s9cg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ni5z8d5s9cg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qv80jh6cox').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qv80jh6cox', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ou1e4o1kogo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ou1e4o1kogo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brs3pkacq4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brs3pkacq4e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ra4m2q3nht"]=  window.__ectimmers["ecom-ra4m2q3nht"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ra4m2q3nht"]["uafqfefow"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ra4m2q3nht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ra4m2q3nht', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a26we33x2vq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a26we33x2vq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ge9o0gsun0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ge9o0gsun0q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewb0xjr0pr6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewb0xjr0pr6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9noiddnbltl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9noiddnbltl', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}